<template>
  <div>
    <v-navigation-drawer
      class="primary1 navigation-left"
      width="60"
      style="z-index: 9999999 !important; height: 100%;"
      :disable-resize-watcher="true"
      :hide-overlay="true"
      v-model="show"
      mobile-breakpoint="768"
      app
    >
      <v-list style="padding-top: 74px;" shaped nav>
        <v-list-item-group v-model="opcao">
          <v-list-item
            v-for="(item, index) in items"
            :key="index"
            @click="menuCadu(index)"
            :href="item.href"
            target="_blank"
            style="margin: 0 !important;"
            :style="
              opcao == index && index == 1
                ? 'background-color: white !important;'
                : 'background-color: #00995d !important'
            "
            :ripple="false"
            link
            class="item-grupo"
          >
            <v-list-item-icon style="margin: 8.5px;">
              <v-icon
                style="margin-top: 3px; width: 30px; min-width: 30px; height: 30px;"
                :style="opcao == index && index == 1 ? 'color: #00995d !important' : 'white'"
                class="white--text"
                >{{ item.icon }}</v-icon
              >
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>

      <v-menu
        content-class="menu-left"
        v-model="menu"
        :close-on-click="true"
        :close-on-content-click="false"
        :nudge-right="60"
        nudge-width="240"
        max-width="240"
        min-width="240"
        transition="slide-x-transition"
        offset-x
      >
        <v-card elevation="23" style="height: 100%; border-radius: 0 25px 25px 0;">
          <v-list class="ml-3">
            <v-subheader class="font-primaria headline font-weight-bold primary1--text mb-4">Sistema Cadu</v-subheader>
            <v-list-group
              v-model="active"
              :prepend-icon="abasCadu[0].icon"
              no-action
              color="black"
              class="list-group-left"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title v-text="abasCadu[0].msg"></v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item v-for="(subItem, index) in itemsUnimedFiltro" :key="index" link class="list-item-left">
                <v-list-item-content @click="entrarUnimed(index)">
                  <v-list-item-title v-html="subItem"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-item>
              <v-row no-gutters>
                <v-col cols="12">
                  <div
                    class="body-1"
                    :class="index > 0 ? 'mt-4 cursor-pointer' : 'cursor-pointer'"
                    v-for="(aba, index) in abasFiltradas"
                    :key="index"
                    @click="roterPath(aba)"
                  >
                    <v-icon style="width: 30px; height: 30px;" class="mt-1" color="primary1">
                      {{ aba.icon }}
                    </v-icon>
                    {{ aba.msg }}
                  </div>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-navigation-drawer>
    <overlay-loading v-model="loadingOverlay" />
    <SucessoModal
      :genericMessage="'Manual baixado com sucesso.'"
      :showSucess="showSuccess"
      @close="showSuccess = false"
    />
    <error-modal v-model="error" :errObj="errObj" />
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'
import { EventBus } from './../../../services/EventBus/EventBus'
import Redirect from '@/services/Redirect'
import Manual from '@/services/Manual/Manual'

export default {
  props: {
    show: Boolean
  },
  data() {
    return {
      opcao: -1,
      itemsUnimed: ['Visualizar', 'Editar'],
      abasCadu: [
        {
          icon: '$vuetify.icon.userNormal',
          msg: 'Minha Unimed',
          roles: ['admin_brasil', 'admin', 'colaborador_brasil', 'colaborador_dirigente', 'colaborador', 'dirigente']
        },
        {
          icon: '$vuetify.icon.monitorNormal',
          msg: 'Consultar Unimeds',
          roles: ['admin_brasil', 'admin', 'colaborador_brasil', 'colaborador_dirigente', 'colaborador', 'dirigente']
        },
        { icon: '$vuetify.icon.usersNormal', msg: 'Cooperados', roles: [] },
        {
          icon: '$vuetify.icon.layersNormal',
          msg: 'Dirigentes',
          roles: ['admin_brasil', 'dirigente', 'colaborador_dirigente']
        },
        {
          icon: '$vuetify.icon.clipboardNormal',
          msg: 'Relatórios',
          roles: ['admin_brasil', 'admin', 'colaborador_brasil', 'colaborador_dirigente', 'colaborador', 'dirigente']
        },
        {
          icon: '$vuetify.icon.settingsNormal',
          msg: 'Administração',
          roles: ['admin_brasil', 'admin', 'colaborador_brasil', 'colaborador_dirigente', 'colaborador', 'dirigente']
        },
        { icon: '$vuetify.icon.refreshccwNormal', msg: 'Transações Online', roles: ['admin_brasil'] },
        { icon: '$vuetify.icon.inboxNormal', msg: 'Pendências', roles: ['admin_brasil'] },
        {
          icon: '$vuetify.icon.heartNormal',
          msg: 'Cadbenef',
          roles: ['admin_brasil', 'admin', 'colaborador_brasil', 'colaborador_dirigente', 'colaborador', 'dirigente']
        }
      ],
      items: [
        { title: 'Dashboard', icon: '$vuetify.icon.home' },
        { title: 'Account', icon: '$vuetify.icon.menu' },
        { title: 'tt', icon: '$vuetify.icon.book', href: '' }
      ],
      menu: false,
      role: '',
      pointer: 'cursor-pointer',
      active: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      },
      tokenBearer: '',
      loadingOverlay: false,
      showSuccess: false,
      error: false
    }
  },
  beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    let decoded = jwtDecode(this.tokenBearer)

    this.acessoCadBenef = decoded.acessoCadBenef
    if (!this.acessoCadBenef) {
      this.abasCadu.pop()
    }

    this.role = decoded.role
  },
  beforeDestroy() {
    EventBus.$off('visualizarUnimed')
    EventBus.$off('editarUnimed')
  },
  computed: {
    abasFiltradas() {
      return this.abasCadu.filter((el, index) => {
        if (index > 0) {
          return el.roles.includes(this.role)
        }
      })
    },
    canEdit() {
      return ['admin_brasil', 'admin', 'dirigente'].includes(this.role)
    },
    itemsUnimedFiltro() {
      return this.itemsUnimed.filter((el, index) => {
        if (index === 0) {
          return el
        } else if (this.canEdit) {
          return el
        }
      })
    }
  },
  methods: {
    entrarUnimed(index) {
      this.active = false
      this.menu = false
      if (index === 0) {
        EventBus.$emit('visualizarUnimed')
      } else {
        EventBus.$emit('editarUnimed')
      }
    },
    roterPath(aba) {
      const msg = aba.msg.toLowerCase()
      switch (msg) {
        case 'minha unimed':
          this.goToMinhaUnimed()
          break
        case 'consultar unimeds':
          this.$router.push('/consultarUnimed')
          break
        case 'dirigentes':
          this.$router.push('/dirigentes')
          break
        case 'administração':
          this.$router.push('/administracao')
          break
        case 'cadbenef':
          this.redirectLink()
          break
        case 'pendências':
          this.$router.push('/pendencias')
          break
        case 'transações online':
          this.$router.push('/transacaoOnline')
          break
        case 'relatórios':
          this.$router.push('/relatorios')
          break
      }
      this.menu = false
    },
    async menuCadu(index) {
      switch (index) {
        case 0:
          if (this.$router.history.current.name !== 'home') this.$router.push('/home')
          break
        case 1:
          this.opcao = 1;
          this.menu = true;
          break;
        case 2:
          await this.downloadFile();
          break
        default:
          this.opcao = index
          this.menu = false
          break
      }
    },
    async downloadFile() {
      this.loadingOverlay = true
          let arquivo = `${this.$appConfig.config.API}/api/arquivos/manual/`;
          let manual = new Manual(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed);
          try {
            let uuidArquivo = await manual.getUuid()
            arquivo += uuidArquivo.data
            let response = await manual.exportar(arquivo)
            let content = response.headers['content-disposition']
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', content.substring(content.indexOf('"'), content.lastIndexOf('"')))
            document.body.appendChild(link)
            link.click()
            this.loadingOverlay = false
            this.showSuccess = true

          } catch (err) {
            this.loadingOverlay = false
            this.error = true
            console.error(err)
            this.showError = true
            this.errObj.status = err.response.status
            this.errObj.error = err.response.status === 404 ? err.response.data.message : 'Erro desconhecido'
          }
    },
    async redirectLink() {
      let redirect = new Redirect(localStorage.getItem('tokenBearer'), this.$appConfig.config.API)
      try {
        let response = await redirect.getCadBenef()
        let url = response.data
        window.open(url, '_blank')
      } catch (err) {
        console.error(err)
      }
    },
    goToMinhaUnimed() {
      EventBus.$emit('breadCrumbPast', 0)
      localStorage.setItem('optionEdit', false)
      this.$router.push({ path: '/minhaUnimed' })
      this.menu = false
    }
  },
  watch: {
    menu() {
      if (!this.menu && this.opcao === 1) {
        this.opcao = -1
        this.active = false
      }
    }
  }
}
</script>

<style>
.v-list-item__avatar:last-of-type:not(:only-child),
.v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {
  margin-left: 2px !important;
}

.v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 12px !important;
}

.item-grupo {
  border-bottom-left-radius: 32px !important;
  border-top-left-radius: 32px !important;
  border-top-right-radius: 0px !important;
  width: 56px;
  left: -3px;
}

.v-list-item--link:before {
  background-color: transparent !important;
}

.v-list-item--link::before {
  transition: none;
}

.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: none !important;
}

.menu-left {
  z-index: 10000 !important;
  border-radius: 0px 25px 25px 0px;
  height: 100%;
  top: 60px !important;
  position: fixed;
}
.cursor-pointer {
  cursor: pointer;
}
.list-item-left {
  min-height: 10px !important;
  height: 28px !important;
}

.list-group-left {
  min-height: 44px;
}
.list-group-left > .v-list-group__header {
  min-height: 10px !important;
  height: 28px !important;
}
.list-group-left > .v-list-group__header > .v-list-item__icon {
  margin-top: 2px !important;
  color: #00995d !important;
}
</style>
